import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue'),
        meta: { public: true },
    },
    {
        path: '/',
        component: () => import('@/layouts/AdminLayout.vue'),
        children: [
            { path: '', name: 'dashboard', component: () => import('@/views/Dashboard.vue') },
            { path: 'tenants', name: 'tenants.index', component: () => import('@/views/tenants/Index.vue') },
            { path: 'tenants/new', name: 'tenants.create', component: () => import('@/views/tenants/Create.vue') },
            { path: 'tenants/:id/modules', name: 'tenants.modules', component: () => import('@/views/tenants/Modules.vue') },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/NotFound.vue'),
        meta: { public: true },
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to) => {
    if (to.meta.public) return true;

    const auth = useAuthStore();
    if (!auth.user) {
        try {
            await auth.fetchUser();
        } catch {
            return { name: 'login', query: { redirect: to.fullPath } };
        }
    }
    return true;
});
